import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../base';
import { GenericCollectionResponse } from '../../entities';
import { ReferralTarget } from './entities';

@Injectable({
  providedIn: 'root'
})
export class ReferralTargetsRepositoryService {
  private api = inject(ApiService);

  getTargets(): Observable<ReferralTarget[]> {
    return this.api.get<GenericCollectionResponse<ReferralTarget>>('/practices/referral-targets')
      .pipe(map(response => response.items));
  }
}
